"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorArea = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = require("@components/base/Button");
var liff_1 = require("@domain/liff");
require("rsuite/dist/rsuite.min.css");
/**
 * 自由記述エラーページ
 * @return {*}
 */
var ErrorArea = function () {
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: { py: 4, px: 2, maxWidth: "600px", margin: "auto" }, children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { sx: { color: "#EA2C24", fontSize: "18px", fontWeight: 500 }, children: "\u30B7\u30B9\u30C6\u30E0\u30A8\u30E9\u30FC" }), (0, jsx_runtime_1.jsxs)(Typography_1.default, { sx: {
                    color: "#39546C",
                    fontSize: "14px",
                    pb: 5,
                    pt: 1,
                    lineHeight: 2,
                }, children: ["\u6A29\u9650\u306E\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002", (0, jsx_runtime_1.jsx)("br", {}), "\u300C\u30C8\u30FC\u30AF\u3078\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u9001\u4FE1\u300D\u3092ON\u306B\u3057\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", (0, jsx_runtime_1.jsx)("br", {}), "\u3046\u307E\u304F\u3044\u304B\u306A\u3044\u5834\u5408\u306F\u3001\u5E97\u8217\u3078\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"] }), (0, jsx_runtime_1.jsx)(Box_1.default, { children: (0, jsx_runtime_1.jsx)("img", { src: "/img/liff_form/error.png", style: { width: "100%", border: "solid #DBE6F0 1px" } }) }), (0, jsx_runtime_1.jsx)(Box_1.default, { sx: {
                    pt: 2,
                    pb: 3,
                    position: "fixed",
                    width: "calc(100% - 32px)",
                    bottom: 0,
                    left: "16px",
                    zIndex: 100,
                    background: "#fff",
                    "& button": { fontSize: "16px", width: "100%" },
                }, children: (0, jsx_runtime_1.jsx)(Box_1.default, { sx: { maxWidth: "600px", margin: "auto" }, children: (0, jsx_runtime_1.jsx)(Button_1.ButtonLarge, { onClick: function () {
                            (0, liff_1.closeWindow)();
                        }, children: "\u30DA\u30FC\u30B8\u3092\u9589\u3058\u308B" }) }) })] }));
};
exports.ErrorArea = ErrorArea;
